// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21pAr","top":"styles_top__2iNUf","left":"styles_left__bxF9X","description":"styles_description__yHEky"};